import React from "react";
import "./find-game-line.scss";
import FindGame from "../find_game/FindGame";
import TypeGamesMenu from "../type_games_menu/TypeGamesMenu";
import AsideButtonFind from "./aside-nav/AsideButtonFind";

export default function FindGameLine({ inputId, hideLobby }) {
  return (
    <div className="find-game-line">
      <div className="find-game-line__folders">
        <TypeGamesMenu hideLobby={hideLobby} />
      </div>

      <div className="find-game-line__search">
        <FindGame inputId={inputId} />
        <AsideButtonFind />
      </div>
    </div>
  );
}
